export default {
  getPerPage: (tab) => {
    return 15
  },
  getHead: () => {
    return [
      {name: 'No.', style: {minWidth: '100px', width: '100px'}},
      {name: '학교(기관) 구분', key: 'facility_category.cat3'},
      {name: '학교(기관)명', key: 'field_name'},
      {name: '학교(기관)장', key: 'director_name'},
      {name: '관리감독자', key: '행정실장'},
      {name: '학교(기관) 담당자', key: 'manager_name'},
      {name: '안전점검기관명'},
    ]
  },
  getCol: (index, row, func) => {
    try {
      switch (index) {
        // No.
        case 0:
          return func.no
        case 1:
          return !!row.facility_category_id ? row.facility_category.cat3 : "-"
        case 2:
          return !!row.field_name ? row.field_name : "-"
        case 3:
          return !!row.director_name ? row.director_name : "-"
        case 4:
          return !!func.meta.행정실장 ? func.meta.행정실장 : "-"
        case 5:
          return !!row.manager_name ? row.manager_name : "-"
        case 6:
          return func.getCompanyNames(row.companies)
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },
  loadFieldList (searchData) {
    const options = {};

    if (searchData.searchType === "field_name") {
      options.keyword = searchData.keyword;
    } else if (!!searchData.searchType) {
      options.metaKey = searchData.searchType;
      options.metaValue = searchData.keyword;
    }

    return options
  },
}
